import { combineReducers } from 'redux';
import questions from './question.reducer';

const questionAppReducer = combineReducers({
    questions,
});

export default questionAppReducer;


// WEBPACK FOOTER //
// src/main/content/question/store/reducers/index.js